var _line, _path, _line2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVideoOff = function SvgVideoOff(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.33565,
    y1: 2,
    x2: 15.1111,
    y2: 15.7755,
    stroke: "white",
    strokeWidth: 1.88889,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.72222 3.88889H1.83642C1.34583 3.88889 0.944443 4.29618 0.944443 4.79398V13.8449C0.944443 14.3427 1.34583 14.75 1.83642 14.75H12.5401C13.0307 14.75 13.4321 14.3427 13.4321 13.8449V12.5988L4.72222 3.88889ZM16.4487 12.9441C16.7595 12.8127 17 12.5096 17 12.1071V6.5227C17 5.71717 16.0367 5.30988 15.4747 5.88009L13.4321 7.9618V4.79398C13.4321 4.29618 13.0307 3.88889 12.5401 3.88889H7.39351L16.4487 12.9441Z",
    fill: "white"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1.33565,
    y1: 2,
    x2: 15.1111,
    y2: 15.7755,
    stroke: "#D92A25",
    strokeWidth: 1.88889,
    strokeLinecap: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVideoOff);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/video-off.5a3983e4b4263381d6f57b37018136c3.svg";